import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import { SubtitleThree } from '../../../../../../styles/theme/default/typography';
import { checkIsRug } from '../../../../../../utils/helper';

const Wrapper = styled.div`
  padding: 20px;
  border-top: 1px solid #d8d8d8;
  border-bottom: 1px solid #d8d8d8;
  padding-top: 20px;
  .title-open-btn {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .content-container {
    margin-top: 30px;
  }
  .dimensions-image {
    width: 100%;
    height: auto;
  }
  .details-container {
    margin-top: 35px;
  }
  a {
    color: ${({ theme }) => theme.colors.french};
  }
`;

const getSlug = sizeId => {
  if ([18].includes(sizeId)) {
    return `supreme-felted-rug-pad-10-x-14-32070`;
  }
  if ([25, 47, 26, 24, 23].includes(sizeId)) {
    return `supreme-felted-rug-pad-3-x-5-32067`;
  }

  if ([48, 49, 30, 35, 42, 43, 45, 32].includes(sizeId)) {
    return `supreme-felted-rug-pad-6-x-9-32068`;
  }

  if ([37, 36, 39, 40, 44].includes(sizeId)) {
    return `supreme-felted-rug-pad-8-x-10-32069`;
  }

  return false;
};

function DetailsAndCare({ productData, openByDefault, foundationSlug }) {
  const [open, setOpen] = useState(openByDefault);
  const hideFabricForCategoryIds = ['27', '28', '29', '30', '31', '32'];
  const fabricExists = productData.fabric;

  const renderCare = compliance => {
    return compliance
      ?.split(/(?:\r\n|\r|\n)/g)
      .map((text, index) => <div key={index}>{text}</div>);
  };

  const renderAdditionalDetails = additionalDetails => {
    const additionalDetailsArray = additionalDetails.split(/(?:\r\n|\r|\n)/g);

    if (additionalDetailsArray.length > 1) {
      return additionalDetailsArray.map((text, index) => (
        <li key={index}>{text}</li>
      ));
    }

    return additionalDetails;
  };

  const padSlug = getSlug(parseInt(productData.frame?.size?.id));
  const isRug = checkIsRug(productData?.frame?.name);

  const isFabricTreatment = productData?.fabric?.treatment?.id == 1;

  return (
    <Wrapper>
      <div className="title-open-btn" onClick={() => setOpen(!open)}>
        <SubtitleThree bold={true}>Details + Product Care</SubtitleThree>
        <Icon
          icon={`ti-arrow-${open ? 'up' : 'down'}`}
          size={12}
          color="black"
        />
      </div>
      {open && (
        <div className="content-container">
          <div className="details-container">
            {productData.frame.frame_materials ? (
              <ConstructionItem>
                <p className="title">Materials</p>
                <div className="content">
                  {!isFabricTreatment && productData.frame.frame_materials}

                  {isFabricTreatment && (
                    <>
                      Construction - {productData.frame.frame_materials}
                      {productData.fabric &&
                      productData.fabric?.material?.composition ? (
                        <>
                          {' '}
                          <br />
                          Fabric - {productData.fabric.material.composition}
                        </>
                      ) : (
                        ''
                      )}
                    </>
                  )}
                </div>
              </ConstructionItem>
            ) : (
              ''
            )}

            {/*{fabricExists && productData.fabric.colors && (*/}
            {/*  <ConstructionItem>*/}
            {/*    <p className="title">Color</p>*/}
            {/*    <div className="content">*/}
            {/*      {productData.fabric.colors.map(color => (*/}
            {/*        <div key={color.name}>{color.name}</div>*/}
            {/*      ))}*/}
            {/*    </div>*/}
            {/*  </ConstructionItem>*/}
            {/*)}*/}

            {productData.frame.size && (
              <ConstructionItem>
                <p className="title">Size</p>
                <div className="content">{productData.frame.size.name}</div>
              </ConstructionItem>
            )}

            {productData.leg && (
              <ConstructionItem>
                <p className="title">Leg Finish</p>
                <div className="content">{productData.leg.name}</div>
              </ConstructionItem>
            )}

            {productData.care && (
              <ConstructionItem>
                <p className="title">Care</p>
                <div className="content">
                  {renderCare(productData.care)}{' '}
                  {productData.fabric?.material?.care ? (
                    <div>
                      {/* <br /> */}
                      {productData.fabric?.material?.care}
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </ConstructionItem>
            )}

            {productData.frame.box_spring && (
              <ConstructionItem>
                <p className="title">Box Spring</p>
                <div className="content">
                  {productData.frame.box_spring}
                  {foundationSlug && (
                    <>
                      {' '}
                      We recommend{' '}
                      <a href={`/products/${foundationSlug}`} target="_blank">
                        The Foundation
                      </a>
                      , guaranteed to work perfectly with your bed frame.
                    </>
                  )}
                </div>
              </ConstructionItem>
            )}

            {productData.frame.ship_method && (
              <ConstructionItem>
                <p className="title">Ship Method</p>
                <div className="content">{productData.frame.ship_method}</div>
              </ConstructionItem>
            )}

            {productData.frame.assembly_instructions && (
              <ConstructionItem>
                <p className="title">Assembly Instructions</p>
                <div className="content">
                  This item requires assembly. Download assembly instructions{' '}
                  <a
                    rel="noopene"
                    style={{ color: '#2A5CAF', textDecoration: 'underline' }}
                    href={`${productData.frame.assembly_instructions}`}
                    target="_blank"
                  >
                    here
                  </a>
                  .
                </div>
              </ConstructionItem>
            )}

            {[64, 66, 105].includes(parseInt(productData?.frame?.id)) && (
              <ConstructionItem>
                <p className="title">Installation</p>
                <div className="content">
                  Apply to a smooth, flat surface. Textured surfaces will NOT
                  work. As for bathrooms, as long as the walls are completely
                  dry when applying and there is good ventilation you should
                  have no problem. A little moisture on the product will be fine
                  as long as it dries quickly. If your bathroom walls remain wet
                  for a while after showering, we do not recommend this product.
                </div>
              </ConstructionItem>
            )}

            {productData.frame.country_of_origin && (
              <ConstructionItem>
                <p className="title">Country of Origin</p>
                <div className="content">
                  {productData.frame.country_of_origin}
                </div>
              </ConstructionItem>
            )}

            {productData.frame.additional_details && (
              <ConstructionItem>
                <p className="title">Additional Details</p>
                <div className="content">
                  <ul className="pl-0">
                    {renderAdditionalDetails(
                      productData.frame.additional_details
                    )}
                    {padSlug && isRug && (
                      <>
                        {' '}
                        Buy one{' '}
                        <Link
                          onClick={() => window.scrollTo(0, 0)}
                          to={`/products/${padSlug}`}
                        >
                          here
                        </Link>
                        .
                      </>
                    )}
                  </ul>
                </div>
              </ConstructionItem>
            )}
          </div>
        </div>
      )}
    </Wrapper>
  );
}

export default DetailsAndCare;

const ConstructionItem = styled.div`
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  .title {
    margin: 0 0 4px 0;
    min-width: 210px;
  }
  @media (max-width: 992px) {
    flex-direction: column;
    border-bottom: none;
  }
`;
